import api from './api';

const markerService = {
  // Get all markers for a timeline
  getTimelineMarkers: async (timelineId) => {
    try {
      const response = await api.get(`/api/timelines/${timelineId}/markers`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get markers for a specific event
  getEventMarkers: async (timelineId, eventId) => {
    try {
      const response = await api.get(`/api/timelines/${timelineId}/events/${eventId}/markers`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create a new marker for an event
  createMarker: async (timelineId, eventId, markerData) => {
    try {
      const response = await api.post(`/api/timelines/${timelineId}/events/${eventId}/markers`, markerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update a marker
  updateMarker: async (markerId, markerData) => {
    try {
      const response = await api.put(`/api/markers/${markerId}`, markerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete a marker
  deleteMarker: async (markerId) => {
    try {
      const response = await api.delete(`/api/markers/${markerId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default markerService;